// FOR SALE page: persisted density switcher + collection/trait bid buttons.
import { openCollectionBidModal } from "./collection-bid.js";
import { pendingChanges } from "./local-changes.js";

const COLS = [24, 12, 4];
const grid = document.getElementById("fs-grid");
const buttons = [...document.querySelectorAll<HTMLElement>(".fs-density [data-cols]")];

const apply = (n: number) => {
  grid?.style.setProperty("--fs-cols", String(n));
  for (const b of buttons) b.classList.toggle("current", Number(b.dataset.cols) === n);
};

const saved = parseInt(localStorage.getItem("mdx-forsale-cols") ?? "", 10);
if (COLS.includes(saved)) apply(saved);

for (const b of buttons) {
  b.addEventListener("click", () => {
    const n = Number(b.dataset.cols);
    localStorage.setItem("mdx-forsale-cols", String(n));
    apply(n);
  });
}

document
  .querySelector("[data-collection-bid]")
  ?.addEventListener("click", () => openCollectionBidModal({ trait: false }));
document
  .querySelector("[data-trait-bid]")
  ?.addEventListener("click", () => openCollectionBidModal({ trait: true }));

// Layer recent local listing changes over the (possibly SWR-cached) grid:
// flip the tile's FOR-SALE status class in place. Idempotent — classList
// add/remove of an already-correct state is a no-op.
for (const c of pendingChanges()) {
  const flip = (monkeId: number | null, onSale: boolean) => {
    if (monkeId == null) return;
    for (const tile of document.querySelectorAll(`a.monke-tile[href="/${monkeId}"]`)) {
      tile.classList.toggle("sale", onSale);
    }
  };
  if (c.t === "listing-created") flip(c.listing.monkeId, true);
  else if (c.t === "listing-cancelled") flip(c.monkeId, false);
  else if (c.t === "sale-pending") flip(c.monkeId, false);
}
